// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"ProfileAvatar_avatarWrapper__7cjjH","settingsIcon":"ProfileAvatar_settingsIcon__7uAd4"};